// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"qa_a bik_i bik_j bik_q bik_vt bik_xl bik_et"};